import {Component, OnInit} from '@angular/core';
import {AuthenticationService} from '../../../services/authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectService} from '../../../services/project.service';
import {CurrentUserService} from '../../../services/currentuser.service';
import {NotificationService} from '../../../services/notification.service';

@Component({
  template: ''
})
export class LogoutComponent implements OnInit {

  constructor(
    private router: Router,
    private currentUserService: CurrentUserService,
    private notificationService: NotificationService

  ) { }


  ngOnInit(): void {
    console.log('logout');
    // this.currentUserService.logoutPressed = true;
    this.currentUserService.setToken(null);
    this.currentUserService.setLogin(null);
    this.currentUserService.setPassword(null);
    this.notificationService.disconnect();
    this.router.navigate(['pages/login'])
  }


}
